// extracted by mini-css-extract-plugin
module.exports = {"drawerFooter":"DrawerFooter_drawerFooter__eKb_b","pickerAbsolute":"DrawerFooter_pickerAbsolute__3VzjU"};